import { InstagramIcon } from "./Icons";
import { SectionTitle } from "./SectionTitle";
import { useSite } from "../../context/SiteContext";
import { imgUrl } from "../../lib/api";
import { IG, IG_HANDLE } from "../../lib/site";

export const InstagramSection = () => {
  const { gallery } = useSite();
  const items = gallery.slice(0, 6);
  return (
    <section className="container-lux py-20 lg:py-28" data-testid="instagram-section">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
        <SectionTitle eyebrow={IG_HANDLE} title="Bizi Instagram’da Takip Edin" sub="Salonumuzdan güncel kareler, kampanyalar ve duyurular için Instagram hesabımızı takip edin." />
        <a href={IG} target="_blank" rel="noopener noreferrer" className="btn-emerald mb-10 shrink-0 self-start sm:self-auto lg:mb-14" data-testid="instagram-follow-btn">
          <InstagramIcon className="h-4 w-4" /> Instagram’da Takip Et
        </a>
      </div>
      <div className="grid grid-cols-3 gap-2 sm:gap-4 lg:grid-cols-6">
        {items.map((g, i) => (
          <a key={g.id || i} href={IG} target="_blank" rel="noopener noreferrer" className="group relative block aspect-square overflow-hidden rounded-xl sm:rounded-2xl" data-testid={`instagram-item-${i}`}>
            <img src={imgUrl(g.url)} alt={g.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <span className="absolute inset-0 flex items-center justify-center bg-emerald-950/0 text-white opacity-0 transition-[opacity,background-color] duration-300 group-hover:bg-emerald-950/45 group-hover:opacity-100">
              <InstagramIcon className="h-6 w-6" />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
};
